/**
 * Skeleton — shadcn Skeleton 어댑터. 기존 width/height/variant/lines API 유지.
 *
 * variant='circle' → border-radius 50% 적용.
 * lines > 1 → 여러 줄 렌더, 마지막 줄은 60% 너비로 자연스럽게 처리.
 */

import { Skeleton as ShadSkeleton } from '@/components/ui/skeleton'
import { cn } from './cn'

interface SkeletonProps {
  /** 너비. 숫자는 px, 문자열은 그대로 사용 */
  width?: string | number
  /** 높이. 숫자는 px, 문자열은 그대로 사용 */
  height?: string | number
  /** 스켈레톤 변형. 기본값 text */
  variant?: 'text' | 'circle' | 'rect'
  /** variant='text'일 때 렌더링할 줄 수 */
  lines?: number
  className?: string
}

function toPx(val: string | number | undefined): string | undefined {
  if (val === undefined) return undefined
  return typeof val === 'number' ? `${val}px` : val
}

export function Skeleton({
  width,
  height,
  variant = 'text',
  lines,
  className,
}: SkeletonProps) {
  // variant='text' + lines > 1 : 여러 줄 플레이스홀더
  if (variant === 'text' && lines && lines > 1) {
    return (
      <div className={cn('flex flex-col gap-2', className)}>
        {Array.from({ length: lines }).map((_, i) => (
          <ShadSkeleton
            key={i}
            className="h-4 rounded"
            style={{
              width: i === lines - 1 ? '60%' : toPx(width) ?? '100%',
              height: toPx(height),
            }}
          />
        ))}
      </div>
    )
  }

  return (
    <ShadSkeleton
      className={cn(
        variant === 'circle' && 'rounded-full',
        variant === 'rect' && 'rounded-none',
        className,
      )}
      style={{ width: toPx(width), height: toPx(height) }}
    />
  )
}
